export default {
  hero_label: 'Case Studies',
  hero_title: 'Case Studies',
  hero_subtitle: 'AI that empowers people on the ground. A record of transformations AIX JAPAN has supported.',
  cat_all: 'All',
  cat_consulting: 'AI Consulting',
  cat_dev: 'System Development',
  cat_poc: 'PoC & Validation',
  cat_product: 'In-house Products',
  read_more: 'View Case',
  back_to_list: 'Back to Case Studies',
  prev_case: 'Previous Case',
  next_case: 'Next Case',
  partner_badge: 'Partner Case',
  meta_industry: 'Industry',
  meta_category: 'Service Type',
  section_challenge: 'Challenge',
  section_challenge_en: 'CHALLENGE',
  section_approach: 'Approach',
  section_approach_en: 'APPROACH',
  section_results: 'Results',
  section_results_en: 'RESULTS',
  section_tools: 'Technologies',
  note_label: 'Note',
  cases: [
    {
      id: 1,
      provider: 'aix',
      partnerLabel: '',
      category: 'System Development',
      industry: 'Printing',
      client: 'Printing Company',
      scale: '',
      title: 'AI System That Automatically Structures Product Data from Large Catalog PDFs',
      summary: 'AI analyzes 100-500MB catalog PDFs and automatically structures product data into CSV, eliminating manual transcription. Running stably in production.',
      challenge: [
        'Product data buried in catalog PDFs needed to be extracted as searchable, usable data',
        'Simple operation the field team would never get lost in (just upload, no login) was a hard requirement',
        'Access control secured via IP restrictions without adding operational burden'
      ],
      approach: [
        'Split PDFs by page and run multimodal AI analysis: column extraction followed by page-by-page CSV conversion',
        'Multi-stage processing with a queue and up to 8 parallel workers to handle 100-500MB PDFs',
        'Delivered user manuals and operational documentation, with full handover to the client environment'
      ],
      results: [
        'Automated the manual transcription and structuring of catalog data',
        'Running stably in production; handed over to the client cloud environment'
      ],
      tools: ['Google Gemini', 'AWS (ECS Fargate / Aurora / S3 / SQS / CloudFront+WAF)', 'Node.js', 'TypeScript', 'React'],
      note: '',
      image: '/assets/aix_case_01.jpg'
    },
    {
      id: 2,
      provider: 'aix',
      partnerLabel: '',
      category: 'System Development',
      industry: 'Construction Equipment Rental',
      client: 'Construction Equipment Rental Company',
      scale: 'Approx. 100 employees',
      title: 'From Supplier Search to Quotation: An Integrated AI Sales Support System',
      summary: 'Developed an integrated AI system covering supplier search, quotation drafting, visit planning, and internal manual search, with in-house maintainability built in.',
      challenge: [
        'New employees relied on veterans’ experience and took a long time researching suppliers',
        'Action planning and quotation drafting were manual and person-dependent',
        'Separate tools for chat and policy lookup made daily work inefficient'
      ],
      approach: [
        'Operations support: display high-track-record suppliers by product name, with phone numbers and contacts',
        'Sales support: suggest optimal action plans from SFA data and auto-generate quotation drafts',
        'In-house enablement: built so the client can adjust and extend the system on their own'
      ],
      results: [
        'Supplier research shortened from asking seniors and manual work to a few seconds of search',
        'Automated action planning and quotation drafting, resolving person-dependency',
        'Light development such as email template changes handled in-house, without outsourcing'
      ],
      tools: ['Azure OpenAI (no-training configuration)', 'RAG', 'Cloud'],
      note: 'Built securely with no data leakage and a no-training configuration. A working demo was provided from the proposal stage to share the finished image.',
      image: '/assets/aix_case_02.jpg'
    },
    {
      id: 3,
      provider: 'aix',
      partnerLabel: '',
      category: 'AI Consulting',
      industry: 'Manufacturing (Die & Mold)',
      client: 'Die & Mold Design and Manufacturing Company',
      scale: 'Approx. 50 employees',
      title: 'Manufacturing AI Adoption That Starts with Foundations the Field Can Actually Use',
      summary: 'Starting with a communication foundation that even IT-unfamiliar staff can use without hesitation, we are supporting the roadmap toward full AI adoption.',
      challenge: [
        'Many employees were unfamiliar with IT; a foundation everyone could use without getting lost was a precondition for AI adoption',
        'Paper-based and repetitive routine work remained, with information scattered'
      ],
      approach: [
        'Implemented Slack as the foundation (15-channel structure, operational rules, company-wide portal)',
        'Streamlined paper-based and routine work by building workflows',
        'Formulated and proposed an AI roadmap: internal knowledge AI, automated drawing checks, and image analysis AI'
      ],
      results: [
        'Completed the internal communication foundation that serves as the landing zone for AI adoption',
        'Built an internal database optimized for the AI era'
      ],
      tools: ['Slack', 'Microsoft 365 (Loop / SharePoint / Entra ID)'],
      note: 'The foundation phase is complete. For the AI adoption phase, internal knowledge AI, automated drawing checks, and image analysis AI have been proposed and scoping is in progress.',
      image: '/assets/aix_case_03.jpg'
    },
    {
      id: 4,
      provider: 'aix',
      partnerLabel: '',
      category: 'AI Consulting',
      industry: 'Manufacturing (Aerospace-related)',
      client: 'Aerospace-related Manufacturer',
      scale: '',
      title: 'On-Premise AI (RAG) Knowledge Search for Standards Documents and Technical Data',
      summary: 'Proposed an on-premise RAG search platform covering standards documents and years of accumulated technical data, with a phased adoption design that keeps confidential documents in-house.',
      challenge: [
        'Every standards revision required staff to manually check changes and investigate impact',
        'Years of technical data went underutilized, with lookups relying on individual memory',
        'Confidential documents could not leave the company, and an on-premise adoption path was undefined'
      ],
      approach: [
        'Standards impact analysis: detect revision points and highlight affected sections of internal procedures',
        'Technical knowledge search: retrieve past designs and know-how through a conversational interface',
        'Phased adoption design: a three-stage path of trial, PoC, and production that yields decision material early'
      ],
      results: [
        'Presented a path to reduce standards-revision work from half a day–several days to minutes–tens of minutes',
        'Veteran-dependent tacit knowledge becomes referenceable by anyone at consistent quality',
        'The trial phase provides decision material before production investment, raising adoption certainty'
      ],
      tools: ['On-premise LLM', 'Vector DB', 'RAG'],
      note: 'All processing completes inside the client environment with no external communication.',
      image: '/assets/aix_case_04.jpg'
    },
    {
      id: 5,
      provider: 'aix',
      partnerLabel: '',
      category: 'PoC & Validation',
      industry: 'Manufacturing (Parts)',
      client: 'Parts Manufacturing Company',
      scale: '',
      title: 'PoC: Data Extraction and Reverse Lookup from Inconsistently Formatted Quality Sheets',
      summary: 'Extracted part numbers, inks, and materials from inconsistently formatted quality sheets (Excel) and validated a material-to-part-number reverse lookup, absorbing the format variance that general-purpose AI struggles with.',
      challenge: [
        'When ink or material designs changed, identifying affected part numbers was manual work',
        'The only source was quality sheets with inconsistent formats, which general-purpose AI tools had failed to handle',
        'A closed method that never sends confidential data to external AI was a requirement'
      ],
      approach: [
        'Structured the problem through interviews and AI vendor comparison, then supported validation design, PoC, and reporting end to end',
        'Absorbed format variance, shifted columns, and multi-version sheets via header-following extraction, Japanese text normalization, and code-pattern extraction',
        'Fully local processing with zero external transmission; search results point to the exact file, cell, and original text'
      ],
      results: [
        'Extraction succeeded on all 9 target sheets; reverse lookup achieved 100% recall and precision across all 10 queries',
        'Absorbed the format variance generative AI struggles with, and presented a path to resolve the issue through master-data construction'
      ],
      tools: ['Python (Excel structured extraction / Japanese normalization / indexing & search)', 'Closed environment, no external AI transmission'],
      note: 'Conducted as a free PoC. Following the evaluation, a paid continuation (scaling to thousands of files, search UI, OCR support) is under proposal.',
      image: '/assets/aix_case_05.jpg'
    },
    {
      id: 6,
      provider: 'aix',
      partnerLabel: '',
      category: 'System Development',
      industry: 'Marketing & Advertising',
      client: 'Affiliate Marketing Company',
      scale: '',
      title: 'Concept-to-Design Support for an Integrated Affiliate Data Analytics AI System',
      summary: 'Supported a system that integrates diverse affiliate services for data consolidation, analytics, and AI recommendations, from concept through requirements definition and basic design.',
      challenge: [
        'Data scattered across 100+ services and core systems needed integration to streamline routine work',
        'Large volumes of affiliate data went unanalyzed and unusable as decision material'
      ],
      approach: [
        'Planned a new marketing tool with AI that automates aggregation, analytics, and reporting, and recommends actions and channels',
        'Provided hands-on support from concept through requirements definition and basic design',
        'Verbalized the vision of non-technical staff and translated it into concrete UI to share the finished image'
      ],
      results: [
        'Established a design projected to save roughly 2–4 person-months through routine-work efficiency',
        'Concretized a concept that consolidates previously unanalyzed data into new service offerings'
      ],
      tools: ['Next.js', 'React', 'TypeScript', 'Neon (PostgreSQL)', 'ASP APIs', 'Vercel'],
      note: 'By translating the staff’s vision into UI, the engagement delivered output beyond expectations and earned high customer satisfaction.',
      image: '/assets/aix_case_06.jpg'
    },
    {
      id: 7,
      provider: 'aix',
      partnerLabel: '',
      category: 'In-house Products',
      industry: 'All Industries',
      client: 'In-house Development',
      scale: '',
      title: 'AI Readiness Assessment — Visualizing Organizational AI Maturity in 5 Dimensions',
      summary: 'A web application that assesses individual and organizational AI maturity across five dimensions and auto-generates personalized improvement advice with AI.',
      challenge: [
        'Organizations want to adopt AI but cannot see their current position and issues, making it hard to know where to start',
        'An entry point was needed to connect assessment results to training and consulting'
      ],
      approach: [
        'Answering questions across 5 dimensions visualizes current levels by category in charts',
        'An LLM dynamically generates improvement advice based on scores and user type (individual / organization)',
        'Supports saving, sharing, and emailing results, functioning as the entry point to training and consulting proposals'
      ],
      results: [
        'AI adoption status and issues are instantly visualized in numbers and charts, becoming the starting point of organizational AI initiatives',
        'Operating as the entry tool of our services: assessment, advice, then training and hands-on support'
      ],
      tools: ['Next.js', 'React', 'TypeScript', 'Supabase', 'OpenAI', 'Vercel'],
      note: '',
      image: '/assets/aix_case_07.jpg'
    },
    {
      id: 8,
      provider: 'aix',
      partnerLabel: '',
      category: 'In-house Products',
      industry: 'All Industries',
      client: 'In-house Development',
      scale: '',
      title: 'Guide AI — A Chrome Extension That Coaches Frontline AI Use',
      summary: 'A Chrome extension that coaches frontline employees using ChatGPT, Claude, and Gemini, including pre-send security checks for confidential information.',
      challenge: [
        'Enable frontline employees who don’t know prompt writing to master AI just by choosing options',
        'Reduce the risk of sending confidential or personal information to external AI'
      ],
      approach: [
        'Automatically detects degraded answer quality and offers numbered improvement options — improve just by choosing',
        'Detects and masks confidential information such as phone numbers and email addresses before sending (supports per-organization keywords)',
        'Designed to work with AI training so employees can practice on the job exactly what they learned'
      ],
      results: [
        'Provides an environment where training carries directly into daily work, helping AI use take root',
        'Using the tool itself builds AI skills and literacy naturally'
      ],
      tools: ['Chrome Extension', 'Google Gemini API', 'Cloudflare Workers'],
      note: 'Planned expansion into a management dashboard for usage visibility and governance.',
      image: '/assets/aix_case_08.jpg'
    }
  ]
};
